<div class="ngx-custom-slider">
    <ngx-slider 
        [options]="props.sliderOptions"
        [formControl]="formControl">
    </ngx-slider>
</div>
